import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getIssueUpdateFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`fields.Title`),
      // currently issue updates using action updates column header
      columnHeader: t(`actionUpdates.columns.title`),
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`fields.Description`),
      // currently issue updates using action updates column header
      columnHeader: t(`actionUpdates.columns.description`),
      displayType: { displayType: 'textarea' },
    },
    files: {
      fieldId: 'files',
      formLabel: t(`fields.newFiles`),
    },
  } as const satisfies FormConfig;
};
